import styled from "styled-components";

export const ScrollableContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 23px;
  max-height: 400px;
  overflow-y: auto;
  padding-right: 20px;

  /* Scrollbar styling */
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;

export const ModalContent = styled.div`
  padding-top: 55px;
  padding-bottom: 55px;
`;

export const ModalContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 40vw;
  box-shadow: 24px 24px 48px rgba(0, 0, 0, 0.2);
  padding: 30px;
  gap: 16px;
  border-radius: 14px;
  background-color: white;
  background-size: cover;
  position: relative; /* Relative position to use as a reference for children */
`;
